/**
 * Created by JackCui on 2021/12/23
 */

export const masterRelationGroupSchemaHandle = {
  handle (node, {info, buttonMap}) {
    const {enableOperationColumn, inlineButtonShowQuantity} = info
    const buttons = buttonMap['section_batch'] || []
    let viewContent = [
      {
        targetType: 'table',
        elementLinks: node.data.columns,
        enableOperationColumn,
        inlineButtonShowQuantity,
        batchButtons: buttons
      }
    ]
    viewContent.unshift({
      targetType: 'buttons',
      buttons,
      maxLength: '5',
      size: 'small'
    })
    node.viewContent = viewContent
    node.info = info
  }
}

export const masterRelationSchemaHandle = {
  handle (node) {
    const {props} = node
    return {
      props: {
        ...props,
        span: '0'
      }
    }
  }
}